import AppRouter from "AppRouter";
import OmronSnackBar from "components/OmronSnackBar";
import { closeSnackbar, openSnackbar } from "features/ui";
import { selectSnackbarInfo } from "features/ui/selectors";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { GlobalStyle } from "styles/GlobalStyle";

import globalAxios, { AxiosError, AxiosResponse } from "axios";
import { useTranslation } from "react-i18next";

const App = (): JSX.Element => {
  const dispatch = useDispatch();
  const [t, i18n] = useTranslation();
  const info = useSelector(selectSnackbarInfo);

  useEffect(() => {
    const error = globalAxios.interceptors.response.use(
      (response: AxiosResponse) => response,
      (e: AxiosError) => {
        const path = window.location.pathname;
        if (e?.response?.status === 401 && path !== "/") {
          dispatch(closeSnackbar());
          window.history.pushState({ status: 401 }, "", "/");
          window.location.href = `/?back=${path}`;
        }
        return Promise.reject(e);
      }
    );
    const cleanup = () => {
      globalAxios.interceptors.response.eject(error);
    };
    return cleanup;
  }, [dispatch]);

  useEffect(() => {
    if (window.history.state?.status === 401) {
      dispatch(
        openSnackbar({
          level: "error",
          message: t("common.message.autoLogout"),
        })
      );
      window.history.replaceState(null, "", "/");
    }
  }, [dispatch, t]);

  // Language読み取り
  useEffect(() => {
    const language = document.cookie
      .split("; ")
      .map((x) => x.split("="))
      .find((x) => x.length === 2 && x[0] === "language");

    if (language) {
      i18n.changeLanguage(language[1]);
    } else {
      const browser_lauguage = window.navigator.language === "ja" ? "ja" : "en";
      i18n.changeLanguage(browser_lauguage);
    }
  }, [i18n]);

  return (
    <>
      <GlobalStyle />
      <OmronSnackBar
        message={t(info.message)}
        isOpen={info.isOpen}
        color={info.level}
        duration={info.duration}
        onClose={() => {
          dispatch(closeSnackbar());
        }}
      />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </>
  );
};

export default App;
